"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverlapLength = void 0;
var iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "getOverlapLength", { enumerable: true, get: function () { return iotv_v3_types_1.getOverlapLength; } });
